import { Popover, Space } from 'antd'
import { FC } from 'react'
import { formatRollerDisplay } from '../../../../../../helpers/format-roller-display'
import CalculationPosition from '../../../../../../types/api/calculation-position'

interface VirtualStampNumberProps {
    data: CalculationPosition
}

const VirtualStampNumber: FC<VirtualStampNumberProps> = ({ data }) => {
    return (
        <Popover
            title={<>Виртуальный (размеры)</>}
            content={
                <Space direction={'vertical'}>
                    <span>Ширина: {data.virtualStamp?.width}</span>
                    <span>Длина: {data.virtualStamp?.length}</span>
                    <span>Ручьи: {data.virtualStamp?.floods}</span>
                    <span>Межэтикетка: {data.virtualStamp?.range}</span>
                    <span>Вал: {formatRollerDisplay(data.virtualStamp?.roller?.roller)}</span>
                </Space>
            }
            placement={'rightBottom'}
        >
            <>Нет</>
        </Popover>
    )
}

export default VirtualStampNumber
